import type { ContractSelection } from './contractSelection';

export type PreparedNQMMOrder = {
  symbol?: string;
  action?: string;
  quantity?: unknown;
  openInModal?: boolean;
  secType?: string;
  orderType?: 'MIDPRICE' | 'LIMIT';
  price?: unknown;
};

export type PreparedNQMMOrderState = {
  symbol: string;
  secType: string;
  action: 'BUY' | 'SELL';
  quantity: string;
  orderType: string;
  price: string;
  selectedContract: ContractSelection;
};

/** Normalize and validate the internal NQMM-to-manual-order event payload. */
export const buildPreparedNQMMOrderState = (
  detail: PreparedNQMMOrder | null | undefined,
): PreparedNQMMOrderState | null => {
  const quantity = Math.floor(Number(detail?.quantity));
  if (
    !detail?.symbol
    || (detail.action !== 'BUY' && detail.action !== 'SELL')
    || !Number.isFinite(quantity)
    || quantity <= 0
  ) {
    return null;
  }

  const symbol = detail.symbol.toUpperCase();
  const secType = (detail.secType || 'STK').toUpperCase();
  const price = Number(detail.price);
  return {
    symbol,
    secType,
    action: detail.action,
    quantity: String(quantity),
    orderType: detail.orderType || 'MIDPRICE',
    price: Number.isFinite(price) && price > 0 ? price.toFixed(2) : '',
    selectedContract: {
      symbol,
      sec_type: secType,
      display_symbol: symbol,
    },
  };
};
